import React from 'react';
import { Button,Container } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';

const admin = require('firebase');

let config = {
  apiKey: "AIzaSyC2cWzw0XHliR6NRcgJFgUQmtctEjOt7Zw",
  authDomain: "riceinspection-16b06.firebaseapp.com",
  databaseURL: "https://riceinspection-16b06.firebaseio.com",
  projectId: "riceinspection-16b06",
  storageBucket: "riceinspection-16b06.appspot.com",
  messagingSenderId: "375935671208",
  appId: "1:375935671208:web:6f1806f4bf5ece8561db9d"
};
admin.initializeApp(config)
const Landing = () => (
  <Container className="landing">
    <h1>Rice inspection of  thailand</h1>
    <h2>สำนักงานคณะกรรมการตรวจข้าว</h2>
    <Link to="/UploadCheckWeight"><Button variant="outline-primary">Guest</Button></Link>
    <Link to="/login"><Button variant="success">เข้าสู่ระบบ</Button></Link>
  </Container>
)
export default withRouter(Landing)